import React from 'react';
import {
    LinkCollectionElement,
    LinkCollectionEntry,
} from '../../../graphql/pimcore/modules/siteContent/types/SiteContentElement';
import Link from '../../common/Link';
import styled from 'styled-components';
import { Button as BaseButton } from '@mui/base/Button';

interface FooterTermsProps {
    /** Collection of footer links, including cookie-settings */
    links: LinkCollectionElement;
}

const FakeLinkButton = styled(BaseButton)(() => ({
    background: 'none',
    border: 'none',
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: 'Poppins',
    color: '#ffffff',
    cursor: 'pointer',
}));

export default function FooterTerms({ links }: FooterTermsProps) {
    return (
        <nav className="footer-terms" role="list">
            {links.links.map((link: LinkCollectionEntry, idx: number) => {
                const target =
                    link.kind === 'externalLinkFieldCollection'
                        ? link.linkUrl
                        : link.kind === 'internalLinkFieldCollection'
                          ? link.linkRoute
                          : undefined;

                const classes = ['font_13', 'text_42', 'no-wrap', 'inline-block'];
                if (target === '#cookies-settings-tool') {
                    classes.push('ot-sdk-show-settings');
                    return (
                        <FakeLinkButton
                            key={idx}
                            type="button"
                            className={classes.join(' ')}
                            style={{ cursor: 'pointer' }}
                            onClick={(e: React.MouseEvent) => {
                                if (window.OneTrust) {
                                    e.stopPropagation();
                                    window.OneTrust.LoadBanner();
                                    window.OneTrust.ToggleInfoDisplay();
                                }
                            }}
                        >
                            {link.linkText}
                        </FakeLinkButton>
                    );
                }

                return <Link key={idx} link={link} className={classes.join(' ')} />;
            })}
        </nav>
    );
}
